import React from 'react';
import styled from 'styled-components';
import {Icon} from '../../elements/Icon/Icon';
import {formDirection} from '../form-mixin/formDirection';
import {fileTypeInput, formSubDetailSetup} from '../form-mixin/formElementSetup';
import {FormGroup} from './form-group/FormGroup';
import {FormLabel} from './labels/FormLabel';
import {WordFix} from './labels/WordFix';

export function FormDetail({children, label, direction, type, icon, isCardEditor, isArrayFormatter}) {
    return (
        <FormDetailWrapper
            label={label}
            icon={icon}
            direction={direction}
            isCardEditor={isCardEditor}
            isArrayFormatter={isArrayFormatter}
            type={type}>
            {children}
        </FormDetailWrapper>
    );
}

const IconContainer = styled.span`
    color: ${({color}) => color};
`;

export const FormDetailWrapper = ({
    name,
    disabled,
    label,
    prefix,
    suffix,
    direction,
    isCardEditor,
    isArrayFormatter,
    children,
    styleFile,
    nonePrefix,
    icon,
}) => (
    <DetailFormGroup
        nonePrefix={nonePrefix}
        styleFile={styleFile}
        disabled={disabled}
        direction={direction}
        prefix={prefix}
        suffix={suffix}
        isCardEditor={isCardEditor}
        isArrayFormatter={isArrayFormatter}
        formDetail>
        {(label || icon) && (
            <FormLabel>
                {label}
                {icon && (
                    <IconContainer color={icon.color}>
                        <Icon name={icon.icon} color={icon.color} />
                        {icon.tooltip}
                    </IconContainer>
                )}
            </FormLabel>
        )}

        <div>
            {prefix && <WordFix htmlFor={name}>{prefix}</WordFix>}
            {children}
            {suffix && <WordFix htmlFor={name}>{suffix}</WordFix>}
        </div>
    </DetailFormGroup>
);

export const DetailFormGroup = styled(FormGroup)`
    color: var(--default-text-color);
    ${({disabled}) => {
        if (!disabled) return null;
        else
            return `
                cursor: not-allowed;
                *{cursor: not-allowed!important;}
            `;
    }}

    ${({isCardEditor, isArrayFormatter}) => {
        if (isCardEditor)
            return `
            > label {
                color: var(--title-text-100);
                margin-top: 20px;
                font-size: var(--text-size-default);
                font-weight: 800;
            }
            `;
        else if (isArrayFormatter)
            return `
            > label {
                color: var(--title-text-100);
                margin-top: 20px;
                font-size: var(--text-size-default);
                font-weight: 800;
            }
            `;
        else return ``;
    }}
    ${({styleFile}) => fileTypeInput(styleFile)};
    ${({direction}) => formDirection(direction)};
    ${({type}) => formSubDetailSetup(type)};
`;

FormDetail.FormGroup = DetailFormGroup;
